import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_LOGS: (
        pageSizeCount,
        pageNumber,
        searchValue
    ) => ({
        url: `/logging?pageSize=${pageSizeCount}&page=${pageNumber}&search=${searchValue}`,
        method: "get",
    }),
};

export const useLogs = (
    pageSizeCount,
    pageNumber,
    searchValue
) =>
    useApiFetcherSWR(
        API_ENDPOINT.GET_LOGS(
            pageSizeCount,
            pageNumber,
            searchValue
        )
    );